import { CameraConfig } from "./types";

export const CAMERA_CONFIG: CameraConfig = {
  VIDEO_CONSTRAINTS: {
    aspectRatio: 4 / 2,
    width: { ideal: 1280 },
    height: { ideal: 720 },
  },
  ORIENTATION_THRESHOLD: {
    min: 80,
    max: 100,
  },
  TIMER_DURATION: 7,
  CAPTURE_START_DELAY: 8000, // 8 seconds
  SOUNDS: {
    degree: "/sounds/90Degrees.wav",
    timer: "/sounds/Timer.mp3",
    frontView: "/sounds/fullView.wav",
    sideView: "/sounds/sideView.wav",
  },
  POSE_IMAGES: {
    front: "/images/measurement/full_side.png",
    side: "/images/measurement/half_side.png",
  },
} as const;

export const STEP_CONFIG = {
  front: {
    title: "Front Pose",
    degreeText: "Place your mobile on the table at 90 degrees",
    poseImage: CAMERA_CONFIG.POSE_IMAGES.front,
    sound: CAMERA_CONFIG.SOUNDS.frontView,
  },
  side: {
    title: "Side Pose", 
    degreeText: "Place your mobile on the table at 90 degrees",
    poseImage: CAMERA_CONFIG.POSE_IMAGES.side,
    sound: CAMERA_CONFIG.SOUNDS.sideView,
  },
} as const;
